// Definition of Variable Constants

import dayjs, { Dayjs } from 'dayjs'

export const PostedDate: [Dayjs, Dayjs] = [dayjs().subtract(2, 'day'), dayjs().subtract(1, 'day')];